<template>
  <div
    class="flex border-b border-zinc-200 bg-zinc-50 dark:border-zinc-700 dark:bg-zinc-800/80"
  >
    <div
      class="w-48 bg-clip px-3 py-2 text-xxs font-bold uppercase tracking-wide text-zinc-500 dark:text-zinc-400"
    >
      {{ keyLabel }}
    </div>

    <div
      class="flex-grow border-s border-zinc-200 bg-clip px-3 py-2 text-xxs font-bold uppercase tracking-wide text-zinc-500 dark:text-zinc-400 dark:border-zinc-700"
    >
      {{ valueLabel }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keyLabel: {
      type: String,
    },
    valueLabel: {
      type: String,
    },
  },
}
</script>
